export default __webpack_public_path__ + "static/media/rheinwaal-logo.7863a0f7.jpeg";